// ai-bescherming.js — vinkje Shipping Protection in de lade (snippets/ai-bescherming.liquid, Rob 2-11). Aan: regel erbij; uit: regel eruit.
// Daarna de lade opnieuw tekenen zoals ai-doos.js doet. Staat er alleen nog de bescherming in het mandje (geen stukken), dan gaat die eruit.
(function () {
  if (window.aiBescherming) return;
  window.aiBescherming = true;
  var SKU = 'AI-PROTECT';
  var eigenFetch = window.fetch.bind(window);

  function secties() {
    var s = [];
    if (document.getElementById('CartDrawer')) s.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    var hoofd = document.getElementById('main-cart-items'), voet = document.getElementById('main-cart-footer');
    if (hoofd && hoofd.dataset.id) s.push({ id: 'main-cart-items', section: hoofd.dataset.id, selector: '.js-contents' });
    if (voet && voet.dataset.id) s.push({ id: 'main-cart-footer', section: voet.dataset.id, selector: '.js-contents' });
    if (document.getElementById('cart-icon-bubble')) s.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return s;
  }
  function teken(json, lijst) {
    if (!json || !json.sections) return;
    lijst.forEach(function (s) {
      var html = json.sections[s.section], doel = document.getElementById(s.id);
      if (!html || !doel) return;
      var nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      var oud = doel.querySelector(s.selector) || doel;
      if (nieuw) oud.innerHTML = nieuw.innerHTML;
    });
    var lade = document.querySelector('cart-drawer');
    if (lade) {
      var overlay = lade.querySelector('#CartDrawer-Overlay');
      if (overlay && lade.close) overlay.addEventListener('click', lade.close.bind(lade));
    }
  }
  async function stuur(url, body) {
    var lijst = secties();
    if (lijst.length) { body.sections = lijst.map(function (s) { return s.section; }); body.sections_url = location.pathname; }
    var r = await window.fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    teken(await r.json(), lijst);
  }
  async function haal() { return eigenFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  async function zet(aan, variant) {
    var regels = (await haal()).items.filter(function (i) { return i.sku === SKU; });
    if (aan && !regels.length) return stuur('/cart/add.js', { items: [{ id: Number(variant), quantity: 1 }] });
    if (!aan && regels.length) { var u = {}; regels.forEach(function (i) { u[i.key] = 0; }); return stuur('/cart/update.js', { updates: u }); }
  }

  document.addEventListener('change', function (e) {
    var vink = e.target && e.target.closest && e.target.closest('#ai-bescherming .ai-bp__vink');
    if (!vink) return;
    var kaart = vink.closest('#ai-bescherming');
    kaart.classList.add('is-bezig');
    zet(vink.checked, kaart.dataset.variant)
      .catch(function (err) { if (window.console) console.warn('ai-bescherming:', err); vink.checked = !vink.checked; })
      .finally(function () { kaart.classList.remove('is-bezig'); });
  });

  // Opruimen na elke mandjewijziging: alleen bescherming over (alle stukken weg) -> eruit; nooit meer dan 1.
  var RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/, timer = null, bezig = false;
  function controleer() {
    clearTimeout(timer);
    timer = setTimeout(async function () {
      if (bezig) return;
      bezig = true;
      try {
        var cart = await haal();
        var bp = cart.items.filter(function (i) { return i.sku === SKU; });
        var rest = cart.items.filter(function (i) { return i.sku !== SKU && i.sku !== 'AI-GIFTBOX'; });
        var u = null;
        if (bp.length && !rest.length) { u = {}; bp.forEach(function (i) { u[i.key] = 0; }); }
        else if (bp.length > 1 || (bp.length === 1 && bp[0].quantity > 1)) { u = {}; bp.forEach(function (i, k) { u[i.key] = k === 0 ? 1 : 0; }); }
        if (u) await stuur('/cart/update.js', { updates: u });
      } catch (e) { /* nooit de winkel breken */ }
      bezig = false;
    }, 600);
  }
  var vorige = window.fetch;
  window.fetch = function (input, init) {
    var p = vorige.apply(this, arguments);
    try { var url = typeof input === 'string' ? input : (input && input.url) || ''; if (RE.test(url) && !bezig) p.then(controleer, function () {}); } catch (e) { /* idem */ }
    return p;
  };
})();
